import { Components, IconButton, Theme } from "@mui/material"
import SvgArrowSquareDown from "ideep-design-system-2/icons/ArrowSquareDown"

export const MuiAccordionSummary: Components<Theme>["MuiAccordionSummary"] = {
  defaultProps: {
    expandIcon: (
      <IconButton sx={{ p: 0 }}>
        <SvgArrowSquareDown />
      </IconButton>
    ),
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: "8px 8px 0 0",
      backgroundColor: theme.palette.primary["3"],
      color: theme.palette.text["16"],
      minHeight: "46px !important",
      height: "auto",
      my: 2,
      fontSize: 14,
      fontWeight: 500,
      "& .MuiAccordionSummary-content": {
        margin: "0 !important",
      },

      "& .MuiAccordionSummary-expandIconWrapper svg path": {
        stroke: theme.palette.text["15"],
      },
    }),
  },
}
